const ko_KR = {
  "产品菜单": "제품 메뉴",
  "关于我们菜单": "회사 소개",
  "帮助中心菜单": "도움말 센터",
  "信用基础": "신용을 기반으로",
  "加密支付": "암호화 결제",
  "全币种支持": "모든 통화 지원",
  "全节点承兑": "풀노드 결제",
  "去中心担保": "탈중앙 보증",
  "立即开始使用": "지금 바로 사용",
  "闪电般的支付体验": "번개 같은 결제 경험",
  "完成跨境支付": "45초 안에 해외 결제 완료",
  "多链支持": "멀티체인 지원",
  "支持主流公链资产": "주요 퍼블릭체인 자산 지원",
  "实时结算": "실시간 정산",
  "无需等待": "초 단위 입금, 대기 필요 없음",
  "超额担保": "초과 담보",
  "资金安全有保障": "자금 안전 보장",
  "一个钱包": "하나의 지갑",
  "所有可能": "모든 가능성",
  "商户收款": "매장 수금",
  "全球化支付网关": "글로벌 결제 게이트웨이",
  "承兑服务": "결제 서비스",
  "稳定可靠的承兑网络": "안정적이고 신뢰할 수 있는 결제 네트워크",
  "数字资产": "디지털 자산",
  "多链资产管理": "멀티체인 자산 관리",
  "下载": "앱 다운로드",
  "多节点承兑": "다중 노드 결제",
  "生态": "NECO 생태계",
  "钱包": "TEPAY 지갑",
  "立即下载": "지금 다운로드",
  "随时汇币": "언제 어디서든 손쉬운 코인 해외송금",
  "走天下": "전 세계 어디든",
  "海量订单": "방대한 주문",
  "日进斗金": "매일 쏟아지는 수익",
  "首页描述": "TePay는 탈중앙화 신용 결제 인프라로, 은행이 아닙니다. 금융 서비스는 수용 노드 네트워크와 블록체인 스마트 계약 네트워크를 통해 제공되며, 담보 및 신용 메커니즘으로 안전하고 규제 준수 거래를 보장합니다. 에스크로와 분쟁 해결은 DAO 중재 시스템으로 관리됩니다. 멀티 체인 상호 운용성과 규제 통합 모듈을 통해 사용자와 상인 모두에게 원활하고 투명한 결제 경험을 제공합니다.",
  "轻松交易": "간편 거래",
  "slide2Text": "TePay 탈중앙 멀티 노드 네트워크를 통해 법정화폐와 디지털 화폐 자유롭게 교환",
  "slide2Info": "TePay는 탈중앙화 결제 플랫폼으로 전통적 은행이 아닙니다. 서비스는 멀티 노드 수용 네트워크를 통해 제공되며, 블록체인 스마트 계약으로 보호됩니다. 과잉 담보 및 신용 점수 메커니즘으로 모든 거래가 안전하고 규제 준수되도록 보장합니다.",
  "全球通用": "전 세계 사용 가능",
  "让每一笔支付": "모든 결제를",
  "瞬间达成": "순간 완료",
  "slide3Text": "강력한 TePay 네트워크에서 법정화폐와 디지털 화폐 자유롭게 거래",
  "slide3Info": "TePay는 단일 통화에 국한되지 않습니다. 탈중앙화 플랫폼으로 다양한 통화를 송금, 수신, 교환 가능하며, 국경을 넘어 통합 경험 제공. 블록체인 기술과 동적 신용 메커니즘으로 자금 안전과 효율성을 보장합니다.",
  "护航每笔交易": "모든 거래 보호",
  "安全无忧": "안전 걱정 없음",
  "slide4Text": "탈중앙 보증 메커니즘으로 각 거래에 신뢰와 안전 제공",
  "slide4Info": "TePay는 전통 은행이 아니며, 탈중앙 보증 메커니즘으로 거래 안전 보장. 과잉 담보, 동적 신용 점수, DAO 중재로 강력한 보장 제공. 기존 금융과 디지털 자산 연결을 안전하고 효율적으로 지원합니다.",
  "一个钱包走天下": "하나의 지갑으로 전 세계 사용",
  "币随时付": "언제든지 코인 결제",
  "跨境无忧": "국경 간 걱정 없음",
  "slide5Text": "법정화폐와 디지털 화폐 모든 자산을 하나의 안전한 지갑에서 관리",
  "slide5Info": "TePay는 금융 세계를 통합하여 하나의 지갑으로 모든 결제 필요를 충족. 자산 관리와 글로벌 거래를 통합하며, 블록체인 기술과 동적 신용 메커니즘으로 원활하고 효율적인 금융 경험 제공.",
  "slide6Text": "상인과 고객의 다양한 통화 요구 충족, 무한 수익",
  "slide6Info": "TePay 동적 매칭 엔진은 법정화폐와 디지털 화폐 간 장벽 제거, 상인과 고객 모두 어떤 통화를 사용하든 수익 가능. 효율적 정산, 모든 거래 수익 극대화.",
  "边兑边赚": "교환하며 수익 창출",
  "信用随行": "신용 동행",
  "slide7Text": "모든 교환에서 수익 증가, 신용 점수 상승",
  "slide7Info": "TePay는 전통 은행이 아니며 탈중앙 보증 메커니즘으로 거래 안전 보장. 과잉 담보, 동적 신용 점수, DAO 중재로 각 거래에 강력한 보장 제공.",
  "下载TEPAY": "TEPAY 다운로드",
  "开启信用支付": "신용 결제 시작",
  "多币种支持": "다중 통화 지원",
  "多节点承兑描述": "멀티 노드 수용",
  "下载Text": "다운로드",
  "链上赋能": "블록체인 기반 커뮤니티 전자상거래",
  "品牌即社区": "브랜드 = 커뮤니티",
  "消费即投资": "소비 = 투자",
  "本地即全球": "로컬 = 글로벌",
  "真实消费": "실제 소비",
  "支撑返利": "리워드 지원",
  "slide2Text": "많이 살수록 많이 돌려받음",
  "slide2Info": "NECO는 주문 완료 및 블록체인 확인 후 토큰과 포인트 생성. 리워드 한도는 상인 할인 20%로 제한, 초과 발행 없음. 모든 보상은 실제 현금 흐름으로 지급, NECO/USAI 거래는 블록체인에서 확인 가능.",
  "透明积分": "투명 포인트",
  "代币经济": "토큰 경제",
  "slide3Text": "포인트 블록체인 등록, 가치 검증 가능",
  "slide3Info1": "소비 리워드는 NECO 토큰과 USAI 스테이블코인으로 나뉨",
  "slide3Info2": "NECO는 일 0.2% 선형 방출, USAI는 소각/발행으로 환율 자동 조정",
  "slide3Info3": "모든 발행, 소각, 방출 이벤트는 스마트 계약 기록, 누구나 잔액, 방출 카운트다운, 거래 기록 실시간 확인 가능",
  "多角色": "다중 역할",
  "激励生态": "인센티브 생태계",
  "slide4Text1": "사용자, 그룹 리더, 상인, 상호 이익 루프",
  "slide4Info1": "사용자: 소비 포인트 100% 환급, NECO 보유 시 권한 및 수익",
  "slide4Info2": "그룹 리더: 그룹 구성, 커뮤니티 운영, 커미션 + NECO 보상",
  "slide4Info3": "상인: 할인으로 정확한 주문 확보, 수수료 0%, 브랜드 홍보",
  "slide4Info4": "3자 수익 모두 동일 블록체인 공식에 기록, 실시간 정산 가능",
  "合规保障": "규제 준수 보장",
  "全程可审": "전 과정 감사 가능",
  "slide5Text": "블록체인 기록, 규제 친화적",
  "slide5Info1": "TePay 게이트웨이는 KYC, 법정화폐 연동, 결제 규제 준수 담당",
  "slide5Info2": "플랫폼은 이중 오라클, 가격 버퍼, DAO 위험 관리 기금으로 극단적 상황 시 속도 제한, 재매입 또는 일시 중지 가능",
  "合作伙伴": "파트너",
  "社区团购": "커뮤니티 공동 구매",
  "社区小店": "커뮤니티 소상점",
  "社区空间": "커뮤니티 공간",
  "社区服务": "커뮤니티 서비스",
  "NECO优选": "NECO 추천",
  "暂未开放": "미개방",
  "新闻标题": "뉴스 센터",
  "新闻1标题": "창세 시작, 앱 출시 및 회원 시스템 안내",
  "新闻1内容": "커뮤니티 회원 여러분:\n\n8월 5일 24:00 (GMT+8) Novai SWAP에서 NECO/nUSDT, USAI/nUSDT 거래쌍 오픈 예정, 플랫폼 코인 및 스테이블코인 창세 시작.\n\n동시에 NECO 앱 정식 등록 가능, 글로벌 회원 시스템 출시. 다음 가능:\n1. 사용자 등록 및 링크 공유\n2. USDT 충전 후 USAI 획득 및 VIP 구매\n3. 창세 노드 및 일반 노드 포인트 해제\n4. 회원 추천 및 팀 포인트 보상 관리\n5. 포인트 해제 후 NECO 사용\n6. NECO → USAI → 인출 (현재 버전 USDT 가능)\n7. 기본 기능 사용: NECO 가격 조회, SWAP 거래 조회, 공지 확인\n\n시간 변경 시 별도 공지 예정",
  "返回": "뒤로",
  "消费返股": "소비 포인트 환급",
  "全球首个": "세계 최초",
  "WEB3社区电商平台": "WEB3 커뮤니티 전자상거래 플랫폼",
  "消费": "소비",
  "赚钱": "수익",
  "持股": "주식 보유",
  "合伙人": "파트너",
  "用户": "사용자",
  "股东": "주주",
  "不只是电商": "단순 전자상거래 아님",
  "更是社区电商": "커뮤니티 전자상거래",
  "共赢闭环": "사용자, 그룹 리더, 상인, 상호 이익 루프",
  "用户描述": "사용자: 소비 포인트 100% 환급, NECO 보유 시 권한 및 수익",
  "团长描述": "그룹 리더: 그룹 구성, 커뮤니티 운영, 커미션 + NECO 보상",
  "商户描述": "상인: 할인으로 정확한 주문 확보, 수수료 0%, 브랜드 홍보",
  "三方描述": "3자 수익 모두 동일 블록체인 공식에 기록, 실시간 정산 가능",
  "购物聊天": "NECO AI로 채팅처럼 쇼핑",
  "边聊边选": "채팅하며 선택",
  "聊天助手实时理解你的对话": "AI 채팅 도우미가 대화 실시간 이해",
  "就能找到你要的东西": "말 한마디로 원하는 것 찾기",
  "AI优选": "AI 추천",
  "的那一刻": "NECO 열었을 때",
  "已经在等你": "적합한 상품과 서비스가 기다림",
  "时尚分身": "패션 어시스턴트",
  "监控价格": "상품 검색 및 가격 모니터링",
  "守护你的消费体验": "소비 경험 보호",
  "三类团购机制": "3가지 공동 구매 메커니즘",
  "附近团": "주변 그룹",
  "熟人团": "지인 그룹",
  "优选团": "추천 그룹",
  "全球战略布局": "글로벌 전략 배치",
  "使命与愿景": "미션과 비전",
  "使命": "미션",
  "愿景": "비전",
  "使命描述": "공정하고 투명하며 참여 가능한 자율 비즈니스 시스템 구축",
  "愿景描述": "전 세계 모든 곳에 커뮤니티 경제의 빛을 밝힘",
  "公告": "공지",
  "铸造销毁协议": "발행 및 소각 계약",
  "SWAP交易": "SWAP 거래",
  "NECO社区电商": "NECO 커뮤니티 전자상거래",
  "菜单": "메뉴",
  "安卓下载": "Android 다운로드",
  "ios下载": "iOS 다운로드",
  "NECO下载": "NECO 앱 다운로드",
  "支持版本": "지원 버전: iOS, Android",
  "当前版本": "현재 버전",
  "跨链桥": "크로스체인 브리지",
  "合作伙伴关系": "파트너십",
  "请加入社交媒体信息": "소셜 미디어 정보에 가입하십시오",
  "联系我们": "연락처",
  "版权所有（公司）": "저작권 소유자 (회사),",
  "联系我们的邮件请填写": "연락처 메일은 작성해주십시오",
  "新闻": "뉴스",
  "网页直连": "웹 직접 연결",
  "铸造与销毁协议": "캐스트 및 파기 계약",
  "更多": "추가",
  "请通过": "통과 요청",
  "与我们联系": "연락처",
  "版权所有": "저작권 소유자",
  "联系": "연결",
  "智能体": "챗봇",

  
  "全球首个": "최초의 글로벌",
  "WEB3社区电商平台": "WEB3 커뮤니티 전자상거래 플랫폼",
  "消费": "소비",
  "持股": "지분 보유",
  "升值": "가치 상승",
  "重新定义消费的价值": "소비의 가치 재정의",
  "让消费成为财富的起点": "소비를 부의 출발점으로 만들다",
  "消费即拥有，分享即收益": "소비는 곧 소유, 공유는 곧 수익",
  "NECO 是一套基于 Web3 技术的智能电商基础设施，通过「消费即持股」机制，让每一位用户在购物时获得真实权益与长期回报。 在这里，消费者不只是用户，更是平台的拥有者和生态的建设者。": "NECO는 Web3 기술 기반의 지능형 전자상거래 인프라로, 「소비는 곧 지분 보유」 메커니즘을 통해 모든 사용자가 쇼핑 시 실제 권익과 장기적 수익을 얻을 수 있습니다. 여기서 소비자는 단순한 사용자가 아니라 플랫폼의 소유자이자 생태계의 건설자입니다.",
  "核心技术": "핵심 기술",
  "基于 Novai Chain 的二层网络": "Novai Chain 기반의 레이어2 네트워크",
  "Neco Chain 是构建在 Novai Chain 之上的高性能二层网络，": "Neco Chain은 Novai Chain 위에 구축된 고성능 레이어2 네트워크로,",
  "专为高频电商与支付结算设计，平均出块时间仅 0.2 秒，TPS 超过 50,000。": "고주파 전자상거래와 결제 정산을 위해 특별히 설계되어 평균 블록 생성 시간은 0.2초이며 TPS는 50,000을 초과합니다.",
  "Neco Chain 将电商的每笔消费行为与激励记录上链，": "Neco Chain은 전자상거래의 모든 소비 행위와 인센티브 기록을 블록체인에 저장하여,",
  "让商业行为具备长期可验证性与可追溯性。": "장기적인 검증 가능성과 추적 가능성을 갖춘 상업 행위를 실현합니다.",
  "高速并行账本结构": "고속 병렬 원장 구조",
  "智能结算与动态费用调节": "지능형 정산 및 동적 수수료 조절",
  "消费凭证 NFT 化与积分资产化": "소비 증명서의 NFT화와 포인트 자산화",
  "核心特性": "핵심 특성",
  "链上结算": "온체인 정산",
  "每笔电商交易 0.2 秒确认，安全透明": "전자상거래 거래마다 0.2초 내 확인, 안전하고 투명함",
  "激励协议": "인센티브 프로토콜",
  "激励消费者、商家、渠道等为NECO做出贡献": "소비자, 판매자, 유통채널 등이 NECO에 기여하도록 인센티브 제공",
  "权益积分": "권익 포인트",
  "用户消费即持有可追踪、可变现的权益积分": "사용자의 소비 행위를 통해 추적 가능하고 현금화 가능한 권익 포인트를 보유",
  "共建共享": "공동 건설 및 공유",
  "首个去中心商业自治组织，共建共享NECO电商": "최초의 탈중앙화 비즈니스 자치 조직, NECO 전자상거래 공동 건설 및 공유",
  "主要产品": "주요 제품",
  "支持电商 RWA 的高性能公链": "전자상거래 RWA를 지원하는 고성능 퍼블릭 체인",
  "稳定币、DEX、去中心信用等电商基础协议": "스테이블코인, DEX, 탈중앙화 신용 등 전자상거래 기초 프로토콜",
  "同时为WEB2和WEB3用户服务的电商APP": "WEB2와 WEB3 사용자 모두를 위한 전자상거래 APP",
  "法币和数字货币统一支付及结算体系": "법정화폐와 디지털 통화 통합 결제 및 정산 시스템",
  "竞争优势": "경쟁 우위",
  "极速公链": "초고속 퍼블릭 체인",
  "0.2 秒出块，支持百万级并发订单及支付交易。": "0.2초 블록 생성, 백만 급 동시 주문 및 결제 거래 지원",
  "全球合规": "글로벌 컴플라이언스",
  "在全球各地通过 DAO 组织进行本地合规运营。": "전 세계 각지에서 DAO 조직을 통해 현지 컴플라이언스 운영 수행",
  "电商 RWA": "전자상거래 RWA",
  "第一个将现实世界电商完全放在链上运行的平台。": "실제 세계 전자상거래를 완전히 온체인에서 운영하는 최초의 플랫폼",
  "商业闭环": "비즈니스 클로즈드 루프",
  "让消费、社交与收益形成价值闭环。": "소비, 소셜, 수익이 가치 클로즈드 루프를 형성하도록 함",
  "全球分销体系让每个用户都能成为品牌的传播者与收益方。": "글로벌 유통 시스템을 통해 모든 사용자가 브랜드의 전파자이자 수익자 될 수 있음",
  "消费者端": "소비자단",
  "注册/消费即得积分奖励，积分每日释放为资产。": "회원가입/소비 시 포인트 보상 획득, 매일 포인트 자산화 해제",
  "商家端": "판매자단",
  "一键接入结算 API，设置折让比例与积分政策。": "원클릭으로 정산 API 접속, 할인 비율 및 포인트 정책 설정",
  "分销端": "유통단",
  "允许全球用户参与分销，共享收益与品牌成长。": "글로벌 사용자의 유통 참여 허용, 수익 및 브랜드 성장 공유",
  "NECO 生态系统": "NECO 생태계",
  "一个融合金融、科技与商业的去中心化生态。": "금융, 기술, 비즈니스가 융합된 탈중앙화 생태계",
  "Neco Chain 公链": "Neco Chain 퍼블릭 체인",
  "商业级高速 Layer 2 网络（Novai L2），提供结算与数据验证基础设施。": "비즈니스급 고속 레이어2 네트워크(Novai L2), 정산 및 데이터 검증 인프라 제공",
  "NECO App": "NECO 앱",
  "用户购物、签到、邀请与分销的统一入口。": "사용자 쇼핑, 체크인, 초대, 유통의 통합 진입점",
  "USAI 稳定币": "USAI 스테이블코인",
  "用于平台内支付与结算的稳定币资产，锚定美元价值。": "플랫폼 내 결제 및 정산에 사용되는 스테이블코인 자산, 달러 가치 연동",
  "U Card 全球消费卡": "U Card 글로벌 소비카드",
  "连接线上线下消费场景，支持积分抵扣与现金返还。": "온라인 오프라인 소비 시나리오 연결, 포인트 공제 및 현금 환급 지원",
  "NECO AI 智能系统": "NECO AI 지능 시스템",
  "通过 AI 分析用户行为，实现个性化推荐与安全风控。": "AI를 통해 사용자 행동 분석, 개인화 추천 및 보안 리스크 관리 실현",
  "消费金融该协议": "소비 금융 프로토콜",
  "提供通用的去中心化金融基础设施，支持电商资产流通。": "범용 탈중앙화 금융 인프라 제공, 전자상거래 자산 유통 지원",
  "稳定币生态": "스테이블코인 생태계",
  "构建覆盖支付、结算与跨境流通的稳定币网络。": "결제, 정산, 국경 간 유통을 아우르는 스테이블코인 네트워크 구축",
  "团队及投资人": "팀 및 투자자",
  "全球化视野 · 多元化背景。": "글로벌 비전 · 다변화된 배경",
  "NECO 团队成员来自新加坡、中国、阿联酋等地，拥有电商、金融科技与区块链技术领域超过十年的行业经验。": "NECO 팀 멤버들은 싱가포르, 중국, UAE 등지 출신으로 전자상거래, 핀테크, 블록체인 기술 분야에서 10년 이상의 업계 경험 보유",
  "投资人": "투자자",
  "运营团队": "운영팀",
  "Moe Farmani": "Moe Farmani",
  "拥有多年欧洲、中东、南美零售企业创业经验,曾创建迪拜领先的数字货币交易所 加密货币的重度信仰者": "유럽, 중동, 남미 지역의 소매기업 창업 경험 다수 보유, 두바이 선도적 디지털 통화 거래소 창립 경력, 암호화폐에 대한 강한 신앙자",
  "Matt Romman": "Matt Romman",
  "从事迪拜房地产和零售行业多年。拥有丰富的跨国公司管理经验。": "두바이 부동산 및 소매업계 종사 이력 다수. 풍부한 다국적 기업 경영 경험 보유",
  "Alex Eric": "Alex Eric",
  "曾任职OKX，负责公司品牌和战略": "OKX 근무 이력, 회사 브랜드 및 전략 담당",
  "Manoharlal": "Manoharlal",
  "Novai Chain Founder， 全面支撑NECO技术落地。": "Novai Chain 설립자, NECO 기술 실현에 전면적 지원",
  "官方路线图": "공식 로드맵",
  "2025 — 创世与启动": "2025 — 제네시스 및 시작",
  "2025 — 增长与市场拓展": "2025 — 성장 및 시장 확장",
  "2026 — 生态深化与 AI 赋能": "2026 — 생태계 심화 및 AI 부여",
  "上半年（Q2–Q3）": "상반기(Q2-Q3)",
  "完成白皮书、制度模型与产品原型开发": "백서, 제도 모델, 제품 프로토타입 개발 완료",
  "组织九大社区进行创世启动": "9개 대형 커뮤니티 조직하여 제네시스 시작",
  "完成 300 个节点招募，发行 NECO & USAI 代币，添加初始流动性池": "300개 노드 모집 완료, NECO & USAI 토큰 발행, 초기 유동성 풀 추가",
  "发布 NECO APP BETA 测试版": "NECO APP BETA 테스트 버전 발표",
  "下半年（Q3–Q4）": "하반기(Q3-Q4)",
  "全球社区运营中心部署完成": "글로벌 커뮤니티 운영센터 배치 완료",
  "NECO 优选店铺与创世商户上线": "NECO 우수 매장 및 제네시스 판매자 온라인 전환",
  "推动注册用户突破 10 万": "등록 사용자 10만 돌파 추진",
  "启动空投及全球电商启动大会": "에어드랍 및 글로벌 전자상거래 시작 대회 개최",
  "Q4：好货推广 & 本地电商": "Q4: 우수 상품 프로모션 & 현지 전자상거래",
  "上线「好货系统」并开放会员商家入驻": "「우수 상품 시스템」 온라인 전환 및 회원 판매자 입점 개방",
  "在主要国家开通 TePay 法币支付": "주요 국가에서 TePay 법정화폐 결제 개통",
  "完成中国、韩国、越南 10 家 NECO Best 本地电商落地": "중국, 한국, 베트남 10개 NECO Best 현지 전자상거래 구축 완료",
  "海外注册用户突破 50 万，VIP 用户突破 5 万": "해외 등록 사용자 50만 돌파, VIP 사용자 5만 돌파",
  "举办第二次社区电商大会，开放跨境卖家注册": "두 번째 커뮤니티 전자상거래 대회 개최, 국경 간 판매자 등록 개방",
  "拓展中东、南美、非洲与欧洲本地市场，整合供应链": "중동, 남미, 아프리카, 유럽 현지 시장 확장, 공급망 통합",
  "注册用户突破 100 万，VIP 用户突破 10 万": "등록 사용자 100만 돌파, VIP 사용자 10만 돌파",
  "Q1–Q2：体系完善": "Q1-Q2: 시스템 완선",
  "跨境卖家突破 10 万，商家数量超 10 万": "국경 간 판매자 10만 돌파, 판매자 수 10만 초과",
  "举办第一届 NECO 电商生态大会": "첫 번째 NECO 전자상거래 생태계 대회 개최",
  "上线稳定币生态与信用体系": "스테이블코인 생태계 및 신용 시스템 온라인 전환",
  "注册用户突破 500 万，VIP 超过 20 万": "등록 사용자 500만 돌파, VIP 20만 초과",
  "Q3–Q4：智能升级": "Q3-Q4: 지능형 업그레이드",
  "获得主要国家支付牌照，全面上线法币支付服务": "주요 국가 결제 라이선스 취득, 법정화폐 결제 서비스 전면 온라인 전환",
  "上线 AI 选品与推荐功能": "AI 상품 선택 및 추천 기능 온라인 전환",
  "商家信用、积分全面上链": "판매자 신용, 포인트 전면 온체인 전환",
  "NECO Best 优选商家突破 100 家": "NECO Best 우수 판매자 100개사 돌파",
  "注册用户突破 1000 万，VIP 超过 50 万": "등록 사용자 1000만 돌파, VIP 50만 초과",
  "加入 NECO": "NECO 참여",
  "消费创造财富，社区共建共享。": "소비는 부를 창출하고, 커뮤니티는 함께 건설하고 공유합니다.",
  "一分钟带你了解NECO": "1분 동안 NECO를 알아보세요",
  "NECO 通过链上透明的返利机制，让每一次消费都能获得真实收益。": "NECO는 체인 상의 투명한 리베이트 메커니즘을 통해 매번의 소비가 진정한 수익을 얻을 수 있도록 합니다.",
  "相比传统电商，NECO 的利润由智能合约按比例即时返还，0 抽佣、0 压货。": "기존 전자상거래에 비해 NECO의 이익은 스마트 계약에 의해 비례적으로 즉시 환급되며, 수수료와 재고 압박이 없습니다.",
  "用户与商家共享增长红利。": "사용자와 판매자가 성장의 혜택을 공유합니다.",
  "全球版": "글로벌 버전",
  "中国版": "중국 버전",
}

export default ko_KR



// WEBPACK FOOTER //
// ./src/i18n/config/ko_KR.js